import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Whitelogo from "../../Images/whitelogo.png";
import { useDispatch, useSelector } from "react-redux";
import { setActiveColumn } from "../../Redux/ActiveColumn/ActiveColumnSlice";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Divider } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import TableViewIcon from "@mui/icons-material/TableView";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LayersIcon from "@mui/icons-material/Layers";
import PaidIcon from "@mui/icons-material/Paid";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import MailIcon from '@mui/icons-material/Mail';

const Sidebar = ({ callBack }) => {
  const Theme = useSelector((state) => state.Theme);
  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  // const MenuData = useSelector((state) => state.MenuData?.result);
  const UserLevel = useSelector((state) => state.UserLevel);
  const MenuData = [
    {
      "$id": "2",
      "Menu_ID": 1,
      "MenuName": "Master",
      "Parent_ID": 0,
      "IsMenu": true,
      "MenuPath": "",
      "IsActive": true
    },
    {
      "$id": "3",
      "Menu_ID": 2,
      "MenuName": "Transaction",
      "Parent_ID": 0,
      "IsMenu": true,
      "MenuPath": "",
      "IsActive": true
    },
    {
      "$id": "3",
      "Menu_ID": 3,
      "MenuName": "Reports",
      "Parent_ID": 0,
      "IsMenu": true,
      "MenuPath": "",
      "IsActive": true
    },
    {
      "$id": "3",
      "Menu_ID": 3,
      "MenuName": "Settings",
      "Parent_ID": 0,
      "IsMenu": false,
      "MenuPath": "Settings",
      "IsActive": true
    },
    {
      "$id": "8",
      "Menu_ID": 7,
      "MenuName": "Account",
      "Parent_ID": 1,
      "IsMenu": false,
      "MenuPath": "mnuAccount",
      "IsActive": UserLevel == 3 ? false : true
    },
    {
      "$id": "17",
      "Menu_ID": 16,
      "MenuName": "Design/Style",
      "Parent_ID": 1,
      "IsMenu": false,
      "MenuPath": "mnuFGDesign",
      "IsActive": true
    },
    {
      "$id": "44",
      "Menu_ID": 43,
      "MenuName": "Packing Challan",
      "Parent_ID": 2,
      "IsMenu": false,
      "MenuPath": "PackingChallan",
      "IsActive": true
    },
    {
      "$id": "59",
      "Menu_ID": 58,
      "MenuName": "Stock Report",
      "Parent_ID": 3,
      "IsMenu": false,
      "MenuPath": "StockReport",
      "IsActive": true
    },
    {
      "$id": "44",
      "Menu_ID": 53,
      "MenuName": "Packing Challan Report",
      "Parent_ID": 3,
      "IsMenu": false,
      "MenuPath": "PackingChallanReport",
      "IsActive": true
    },
    {
      "$id": "44",
      "Menu_ID": 54,
      "MenuName": "Sale Report",
      "Parent_ID": 3,
      "IsMenu": false,
      "MenuPath": "SaleReport",
      "IsActive": true
    },
  ].filter((item) => item?.IsActive)
  const ActiveColumn = useSelector((state) => state.ActiveColumn);
  const dispatch = useDispatch();
  const location = useLocation();
  const [MenuDataWithExpand, setMenuDataWithExpand] = useState(MenuData?.map((Menu) => {
    if (Menu?.IsMenu) {
      return { ...Menu, IsExpand: false }
    } else {
      return { ...Menu }
    }
  }));


  const ParentLvl = () =>
    MenuDataWithExpand?.filter((item) => {
      return item?.Parent_ID == 0;
    });
  const ChildLvl = (child) =>
    MenuDataWithExpand?.filter((item) => {
      return item?.Parent_ID == child?.Menu_ID;
    });

  const MenuDataArr = ParentLvl()?.map((elem) => {
    if (elem?.IsMenu) {
      return {
        ...elem,
        childs: ChildLvl(elem)?.map((ele) => {
          if (ele?.IsMenu) {
            return { ...ele, childs: ChildLvl(ele) };
          } else {
            return { ...ele };
          }
        }),
      };
    } else {
      return { ...elem };
    }
  });

  const handleExpandChange = (MenuId) => {
    const updatedArray = MenuDataWithExpand?.map((item) => {
      if (item?.Menu_ID === MenuId) {
        return { ...item, IsExpand: !item.IsExpand };
      } else {
        return { ...item };
      }
    });

    setMenuDataWithExpand(updatedArray);
  };


  const active = {
    backgroundColor: "#F0F2F5",
    color: "#222",
    borderTopLeftRadius: "30px",
    borderBottomLeftRadius: "30px",
    borderTopRightRadius: "5px",
    borderBottomRightRadius: "5px",
  };

  const theme = createTheme({
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiAccordionDetails: {
        styleOverrides: {
          root: {
            margin: "0px",
            padding: "0px 0px 0px 10px",
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            margin: "0px",
            padding: "0px",
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            margin: "1px 0",
            paddingLeft: "7px",
            marginLeft: "10px",
            borderTopLeftRadius: "5px",
            borderBottomLeftRadius: "5px",
            borderTopRightRadius: "10px",
            borderBottomRightRadius: "10px",
            transition: "0.3s",
            "&:hover": active,
          },
        },
      },
      MuiListItemText: {
        styleOverrides: {
          root: {
            paddingLeft: "10px",
          },
        },
      },
    },
  });

  const themeLeft = createTheme({
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiAccordionDetails: {
        styleOverrides: {
          root: {
            margin: "0px",
            padding: "0px 0px 0px 10px",
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            margin: "0px",
            marginLeft: "7px",
            padding: "0 5px 0 5px",
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            margin: "1px 0",
            paddingLeft: "7px",
            marginLeft: "10px",
            borderTopLeftRadius: "5px",
            borderBottomLeftRadius: "5px",
            borderTopRightRadius: "10px",
            borderBottomRightRadius: "10px",
            transition: "0.3s",
            "&:hover": active,
          },
        },
      },
      MuiListItemText: {
        styleOverrides: {
          root: {
            paddingLeft: "10px",
          },
        },
      },
    },
  });

  return (
    <>
      <div className="sidebar">
        <ThemeProvider theme={theme}>
          <Box
            direction="row"
            sx={{
              height: "110px",
              color: "#fff",
              backgroundColor: Theme.primaryThemeColor,
              position: "sticky",
              top: 0,
            }}
          >
            <NavLink
              to={`/CompanyDashboard`}
              onClick={() => dispatch(setActiveColumn("CompanyDashboard"))}
              className="text-decoration-none"
            >
              <img src={Whitelogo} style={{
                width: "170px",
                padding: "10px",
              }} />
              <Typography sx={{ ml: 8, mb: 1, color: "#fff", fontSize: "18px" }}>
                Vendor
              </Typography>
            </NavLink>
            <Divider sx={{
              borderColor: "#fff",
              opacity: 0.5,
            }} />
          </Box>
          <Box
            sx={{
              height: `calc(${"100vh"} - 110px)`,
              color: "#fff",
              backgroundColor: Theme.primaryThemeColor,
              overflowY: "scroll",
              "::-webkit-scrollbar": {
                display: "none"
              },
            }}
          >
            <List>
              <NavLink
                to={`/CompanyDashboard`}
                onClick={() => {
                  return (callBack != undefined ? callBack() : null), dispatch(setActiveColumn("CompanyDashboard"))
                }}
                style={{ color: "#fff", textDecoration: "none" }}
              >
                <ListItem disablePadding>
                  <ListItemButton
                    style={
                      "CompanyDashboard" == ActiveColumn
                        ? active
                        : null
                    }
                  >
                    <SpaceDashboardIcon />
                    <ListItemText primary={"Dashboard"} />
                  </ListItemButton>
                </ListItem>
              </NavLink>
              {/* <NavLink to="#" onClick={() => { return (callBack != undefined ? callBack() : null), dispatch(setActiveColumn("#")) }} style={{ color: "#fff", textDecoration: "none" }} >
                <ListItem disablePadding>
                  <ListItemButton style={"#" == ActiveColumn ? active : null}>
                    <TableViewIcon />
                    <ListItemText primary={"CRM"} />
                  </ListItemButton>
                </ListItem>
              </NavLink> */}
              {MenuDataArr?.map((item, index) => {
                if (item?.IsMenu) {
                  return (
                    <ListItem disablePadding key={index}>
                      <Accordion
                        expanded={item?.IsExpand}
                        onChange={() => handleExpandChange(item?.Menu_ID)}
                        style={{
                          backgroundColor: Theme.primaryThemeColor,
                          color: "#fff",
                          width: "100%",
                          boxShadow: "none",
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <ArrowDropDownIcon
                              sx={{ color: item?.IsExpand ? "#222" : "#fff" }}
                            />
                          }
                          aria-controls="panel2-content"
                          id="panel2-header"
                          style={{
                            background: item?.IsExpand
                              ? `linear-gradient( to top, ${Theme.primaryThemeColor}, #e6e7e8)`
                              : "transparent",
                            color: item?.IsExpand ? "#222" : "#fff",
                          }}
                        >
                          {item?.MenuName == "Master" ? (
                            <PersonOutlineIcon />
                          ) : item?.MenuName == "Transaction" ? (
                            <PaidIcon />
                          ) : (
                            <ReceiptLongIcon />
                          )}
                          <Typography
                            sx={{
                              paddingLeft: "10px",
                              fontWeight: item?.IsExpand ? 600 : 400,
                            }}
                          >
                            {item?.MenuName}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ marginTop: -2 }}>
                          <ThemeProvider theme={themeLeft}>
                            <List>
                              {item?.childs?.map((elem, index) => {
                                if (elem?.IsMenu) {
                                  return (
                                    <ListItem disablePadding key={index}>
                                      <Accordion
                                        expanded={elem?.IsExpand}
                                        onChange={() =>
                                          handleExpandChange(elem?.Menu_ID)
                                        }
                                        style={{
                                          backgroundColor:
                                            Theme.primaryThemeColor,
                                          color: "#fff",
                                          width: "100%",
                                          boxShadow: "none",
                                          marginBottom: "-5px",
                                        }}
                                      >
                                        <AccordionSummary
                                          expandIcon={
                                            <ArrowDropDownIcon
                                              sx={{
                                                color: elem?.IsExpand
                                                  ? "#222"
                                                  : "#fff",
                                              }}
                                            />
                                          }
                                          aria-controls="panel2-content"
                                          id="panel2-header"
                                          style={{
                                            paddingLeft: "15px",
                                            background: elem?.IsExpand
                                              ? `linear-gradient( to top, ${Theme.primaryThemeColor}, #e6e7e8)`
                                              : "transparent",
                                            color: elem?.IsExpand
                                              ? "#222"
                                              : "#fff",
                                          }}
                                        >
                                          <SellOutlinedIcon />
                                          <Typography
                                            sx={{
                                              paddingLeft: "10px",
                                              fontWeight: elem?.IsExpand
                                                ? 600
                                                : 400,
                                            }}
                                          >
                                            {elem?.MenuName}
                                          </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails
                                          sx={{ marginTop: -2 }}
                                        >
                                          <List>
                                            {elem?.childs?.map((ele, index) => {
                                              return (
                                                <NavLink
                                                  to={`/${ele?.MenuPath}`}
                                                  onClick={() => {
                                                    return (callBack != undefined ? callBack() : null),
                                                      dispatch(setActiveColumn(ele?.MenuPath))
                                                  }}
                                                  style={{
                                                    color: "#fff",
                                                    textDecoration: "none",
                                                  }}
                                                  key={index}
                                                >
                                                  <ListItem>
                                                    <ListItemButton
                                                      style={
                                                        ele?.MenuPath == ActiveColumn ? active
                                                          : null
                                                      }
                                                    >
                                                      <LayersIcon />
                                                      <ListItemText
                                                        primary={ele?.MenuName}
                                                      />
                                                    </ListItemButton>
                                                  </ListItem>
                                                </NavLink>
                                              );
                                            })}
                                          </List>
                                        </AccordionDetails>
                                      </Accordion>
                                    </ListItem>
                                  );
                                } else {
                                  return (
                                    <NavLink
                                      to={`/${elem?.MenuPath}`}
                                      onClick={() => {
                                        return (callBack != undefined ? callBack() : null),
                                          dispatch(setActiveColumn(elem?.MenuPath))
                                      }}
                                      style={{
                                        color: "#fff",
                                        textDecoration: "none",
                                      }}
                                      key={index}
                                    >
                                      <ListItem>
                                        <ListItemButton
                                          style={
                                            elem?.MenuPath == ActiveColumn ? active
                                              : null
                                          }
                                        >
                                          <LayersIcon />
                                          <ListItemText
                                            primary={elem?.MenuName}
                                          />
                                        </ListItemButton>
                                      </ListItem>
                                    </NavLink>
                                  );
                                }
                              })}
                            </List>
                          </ThemeProvider>
                        </AccordionDetails>
                      </Accordion>
                    </ListItem>
                  );
                } else {
                  return (
                    <NavLink
                      to={`/${item?.MenuPath}`}
                      onClick={() => {
                        return (callBack != undefined ? callBack() : null),
                          dispatch(setActiveColumn(item?.MenuPath))
                      }}
                      style={{ color: "#fff", textDecoration: "none" }}
                      key={index}
                    >
                      <ListItem disablePadding>
                        <ListItemButton
                          style={
                            item?.MenuPath == ActiveColumn ? active
                              : null
                          }
                        >
                          {item?.MenuName == "Settings" ? (
                            <SettingsIcon />
                          ) : (
                            <ImportExportIcon />
                          )}
                          <ListItemText primary={item?.MenuName} />
                        </ListItemButton>
                      </ListItem>
                    </NavLink>
                  );
                }
              })}
              {/* <NavLink
                to={`/EmailBSMS`}
                onClick={() => {
                  return (callBack != undefined ? callBack() : null),
                    dispatch(setActiveColumn("EmailBSMS"))
                }}
                style={{ color: "#fff", textDecoration: "none" }}
              >
                <ListItem disablePadding>
                  <ListItemButton
                    style={
                      "EmailBSMS" == ActiveColumn
                        ? active
                        : null
                    }
                  >
                    <MailIcon />
                    <ListItemText primary={"Email/BSMS"} />
                  </ListItemButton>
                </ListItem>
              </NavLink> */}
            </List>
          </Box>
        </ThemeProvider>
      </div>
    </>
  );
};

export default Sidebar;
